import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';

/**
 * Asset quotation parameters
 */
export class AssetQuotationParams {
	/**
	 * Agent UUID
	 */
	agentUuid?: string;

	/**
	 * Duration Unit
	 */
	durationUnit!: DurationUnitEnum;

	/**
	 * Date From
	 */
	@TransformDate()
	dateFrom!: Date;

	/**
	 * Date To
	 */
	@TransformDate()
	dateTo!: Date;

	/**
	 * Pricing items
	 */
	pricingItems?: PricingItemDto[];
}
